<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="700px">
    <template v-slot:title>Add Log Entry</template>
    <v-row>
      <v-col>
        <v-textarea
          rows="5"
          v-model="message"
          :outlined="outlinedInputs"
          label="Message"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="6" class="py-0">
        <v-select
          v-model="messageType"
          :items="messageTypes"
          label="Type"
          :outlined="outlinedInputs"
          item-text="name"
        ></v-select>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" :disabled="!isValid" @click="onSave">Save</v-btn>
    </template>
    <v-row v-if="debug">
      <code>selected:{{ messageType }} -{{ itineraryLogUserTypes }}</code>
    </v-row>
  </basic-dialog>
</template>

<script>
import gql from "graphql-tag";
import BasicDialog from "../shared/BasicDialog";
import { removeGQLTypename } from "../../../helpers";

const MESSAGE_TYPES = gql`
  {
    itineraryLogUserTypes {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
export default {
  name: "add-log-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
  },

  components: {
    BasicDialog,
  },

  data() {
    return {
      debug: false,
      message: "",
      messageType: "",
    };
  },

  computed: {
    isValid() {
      return this.message != "" && this.messageType != "";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    messageTypes() {
      return this.itineraryLogUserTypes && this.itineraryLogUserTypes.edges
        ? this.itineraryLogUserTypes.edges.map(removeGQLTypename)
        : [];
    },
  },

  methods: {
    onSave() {
      this.$emit("create", {
        message: this.message,
        messageType: this.messageType,
      });
    },
  },

  apollo: {
    itineraryLogUserTypes: {
      query: MESSAGE_TYPES,
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/ItineraryDetailsAddLogDialog.vue